import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Col, Container, Row, Spinner } from 'reactstrap';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { IProject, IProposition, IUser } from 'src/model';
import { getAcceptedProposition , getMe, getMyProposition, getProject, getUser  } from '../../services';
import { ProjectDisplayWithRouter } from './ProjectDisplay';
import { ProjectEditionWithGlobalContext } from './ProjectEdition';
import { ProjectEvaluation } from './ProjectEvaluation/ProjectEvaluation';
import { ProjectNavWithGlobalContext } from './ProjectNav/ProjectNav';
import { ProjectPropositions } from './ProjectPropositions/ProjectPropositions';
import { ProjectWorkspaceWithGlobalContext } from './ProjectWorkspace/ProjectWorkspace';
import { PropositionEdition } from './PropositionEdition/PropositionEdition';

interface IProjectState {
  client: IUser | null;
  consultant: IUser | null;
  project: IProject | null;
  proposition: IProposition | null;
}

class Project extends React.Component<
  IGlobalContextProps & RouteComponentProps,
  IProjectState
> {
  constructor(props: IGlobalContextProps & RouteComponentProps) {
    super(props);
    this.state = {
      client: null,
      consultant: null,
      project: null,
      proposition: null,
    };
  }

  public handlePropositionChange = (proposition: IProposition) => {
    this.setState({ proposition });
  };

  public handleProjectChange = (project: IProject) => {
   /// this.setState({ project });
   //  alert('set state prject')
  };

  public async componentDidMount() {
    const { updateProject } = this.props.context;
    const user = await getMe();
    const projectId = (this.props.match.params as any).id;
    const project = await getProject(projectId);
    if (project) {
     updateProject(project);
     this.setState({project});
      if (user && project) {
        const client = await getUser(project.clientId);
        if (user && user.type === 'client') {
          const proposition = await getAcceptedProposition(projectId);
          if (proposition) {
            const consultant = await getUser(proposition.consultantId);
            this.setState({ consultant, proposition , project });
          }
        } else {
          const proposition = await getMyProposition(projectId);
          if (proposition) {
            const consultant = await getUser(proposition.consultantId);
            this.setState({ consultant, proposition });
          }
        }
        this.setState({ client });
      }
    }
  }

  public render() {
    // alert('render');
    const {  project, user } = this.props.context;
    const { location, match } = this.props;
    const { client, consultant,  proposition } = this.state;
    const pathname = location.pathname.replace(
      `/project/${(match.params as any).id}/`,
      ''
    );

    return project ? (
      <Row style={{ minHeight: 'calc(100% - 145px)' }}>
        <ProjectNavWithGlobalContext
          pathname={pathname}
          project={project}
          proposition={proposition}
        />
        <Col md='10'>
          {pathname === '' &&
            (user &&
            user.type === 'client' &&
            project.meta.status !== 'started' && project.meta.status !== 'canceled' &&
            project.meta.status !== 'ended' ? (
              <ProjectEditionWithGlobalContext project={project} />
            ) : (
              proposition && (
                <ProjectDisplayWithRouter
                  project={project}
                  proposition={proposition}
                  handlePropositionChange={this.handlePropositionChange}
                />
              )
            ))}
          {pathname === 'consultants' && (
            <ProjectPropositions handleProjectChange={this.handleProjectChange}   project={project} />
          )}
          {pathname === 'workspace' &&
            client &&
            consultant &&
            project &&
            proposition && (
              <ProjectWorkspaceWithGlobalContext
                client={client}
                consultant={consultant}
                project={project}
                proposition={proposition}
              />
            )}
          {pathname === 'evaluation' &&
            consultant &&
            project &&
            project.proposition && (
              <ProjectEvaluation
                consultant={consultant}
                proposition={project.proposition}
              />
            )}
          {pathname === 'proposition' &&
            proposition &&
            proposition.meta.status !== 'hidden' && (
              <PropositionEdition
                project={project}
                proposition={proposition}
                handlePropositionChange={this.handlePropositionChange}
              />
            )}
        </Col>
      </Row>
    ) : (
      <Container
        className='d-flex flex-column justify-content-around align-items-center'
        style={{ minHeight: 'calc(100% - 145px)' }}
      >
        <div className='d-flex flex-column align-items-center'>
          <Spinner type='grow' color='primary' />
          <span className='mt-3'>Chargement...</span>
        </div>
      </Container>
    );
  }
}

export const ProjectWithGlobalContext = withGlobalContext(withRouter(Project));



// WEBPACK FOOTER //
// ./src/components/Project/Project.tsx